import { useCallback, useMemo } from 'react'

import { useHistory } from 'components/ReactRouterProvider/context'
import { useAppSelector } from 'store'

import { ViewQueryState, encodeViewQueryParams } from './filter-params'
import { HSExploreView } from './types'

const VIEW_SESSION_KEY = 'hs-explorer-view-state'

interface HSExploreViewSession {
  activeView: HSExploreView
  setAsPremium: boolean
}
export default function useSyncViewState() {
  const history = useHistory()
  const isPremiumExplorerEnabled = useAppSelector(
    (state) => state.college.record?.Features?.SupportsPremiumHighSchoolExplorer || false,
  )

  const urlState = useMemo(() => new URLSearchParams(history.location.search), [history.location.search])
  const sessionView = useMemo(() => {
    const stored = sessionStorage.getItem(VIEW_SESSION_KEY)
    if (!stored) return undefined

    try {
      /* TODO: We need to manually decode our visitrange so we get a Date object like UIFilters expects. 
      We should improve this with better validation. See https://scoir-dev.atlassian.net/jira/software/projects/HE/boards/82?selectedIssue=HE-184 
      */
      const exploreViewSession = JSON.parse(stored) as HSExploreViewSession
      if (isPremiumExplorerEnabled !== exploreViewSession?.setAsPremium) return undefined
      return exploreViewSession.activeView
    } catch {
      return undefined
    }
  }, [history.location.search])

  const syncStateToUrl = useCallback(
    (state: ViewQueryState, activeView?: HSExploreView) => {
      const newParams = encodeViewQueryParams(state, urlState)
      const searchString = newParams.toString()
      history.replace({
        search: searchString,
      })
      sessionStorage.setItem(
        VIEW_SESSION_KEY,
        JSON.stringify({
          activeView,
          setAsPremium: isPremiumExplorerEnabled,
        }),
      )
    },
    [urlState, history],
  )

  return { urlState, sessionView, syncStateToUrl }
}
